































// vendor
import { defineComponent, ref, PropType, set, computed } from "@vue/composition-api";
// project
import { FindAsset } from "@/components.assets/find-asset";
// local
import { AssetPointer } from "@/psychlab/types";
import { FormParams } from "../../ts/templates/Form";

export default defineComponent({

	components:{
		FindAsset
	},
	props:{
		parameters:{
			type:Object as PropType<FormParams>,
			required:true
		}
	},
	setup(props){

		const asset = computed({
			get:() => props.parameters.asset,
			set:(v) => props.parameters.asset = v
		});

		return {
			asset
		};
	}
});



